// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"342":"3dacebd0","442":"e42948dc","745":"3400707d","996":"c40be804"}[chunkId] + ".chunk.js";
};